import PasswordForm from './PasswordForm';

export default PasswordForm;


// WEBPACK FOOTER //
// ./src/components/PasswordForm/index.jsx